var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"bonus-report",class:_vm.computedClass,attrs:{"fluid":""}},[_c('BonusScorecards',{attrs:{"items":_vm.items,"current-bonus-type":_vm.currentBonusType,"loading":_vm.dataLoading,"error":_vm.dataError},on:{"reload":_vm.loadData},model:{value:(_vm.datePeriod),callback:function ($$v) {_vm.datePeriod=$$v},expression:"datePeriod"}}),_c('BonusTabs',{attrs:{"agent":_vm.agent,"has-bonus-data":{
			availableBonuses: _vm.bonusTypesDataAvailable,
			loading: _vm.dataLoading,
			error: _vm.dataError,
		}},model:{value:(_vm.currentBonusType),callback:function ($$v) {_vm.currentBonusType=$$v},expression:"currentBonusType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }